import { render, staticRenderFns } from "./EFormMatriculas.vue?vue&type=template&id=02d1d891&scoped=true"
import script from "./EFormMatriculas.vue?vue&type=script&lang=js"
export * from "./EFormMatriculas.vue?vue&type=script&lang=js"
import style0 from "./EFormMatriculas.vue?vue&type=style&index=0&id=02d1d891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d1d891",
  null
  
)

export default component.exports